import { ForceLayout } from '@antv/layout/lib/layout/force';

export default ForceLayout;
